import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import { of, timer, Subject } from 'rxjs';
import { debounce, debounceTime } from 'rxjs/operators';


import Util from '../shared/utility';

import { Options } from 'ng5-slider';

@Component({
    selector: 'app-medicare-means-testing',
    templateUrl: './medicare-means-testing-v2.component.html',
    styleUrls: ['./medicare-means-testing-v2.component.css']
})
export class MedicareMeansTestingComponentV2 implements OnInit {
    public client: any;

    public areaChartData: any[];
    public highestBracketExpense: number;

    public clientBenefit: string = null;
    public spouseBenefit: string = null;

    public lineChartData: any;

    public surcharges: string = '$0';
    public medicarePremiums: string = '$0';
    public totalMedicareCost: string = '$0';
    public totalSavings: string = '$0';
    
    public startingSurchargeAmount: number = -1;
    public startingIllustration: any[];

    public magiMessage: string = "Reducing your projected MAGI (Modified Adjusted Gross Income) may lower or eliminate future surcharges. Allocating future income towards product that does not impact MAGI may result in significant savings.";
    public ssbMessage: string = "Your actual monthly benefit in the first year you collect Social Security. Note: This will likely vary from your Primary Insurance Amount (PIA) as it includes future cost-of-living adjustments (COLAs) and changes to your benefit amount based on claim age.";
    public initialBracketOneMessage: string = "Your retirement income projections <b>do not</b> show any impact from Medicare surcharges. If your income expectations change in the future, you can update your Client Profile and re-visit this page."

    // public ssClientAge: number = 65;
    // public ssSpouseAge: number = 65;

    public doughnutChartData = [];
    public mmtData: any;

    public magi: number = 100;

    public sliderOptions: Options = {
        floor: 0,
        ceil: 100,
        animate: false,
        showSelectionBar: true,
        translate: (value: number): string => (value + '%')
    }

    public doughnutChartSettings = {
        view: [400, 400],
        colorScheme: { domain: ['#7DB72F', '#3A87C7'] },
        showLegend: true,
        explodeSlices: true,
        showLabels: false,
        doughnut: true,
        gradient: false,
        maxYAxisTickLength: 16,
        maxXAxisTickLength: 16,
        arcWidth: 0.4,
        tooltipText: (data) => {
            return this.formatCurrency(data.value);
        },
        onSelect: (e) => {}
    }

    public areaChartSettings = {
        showXAxis: false,
        showYAxis: true,
        gradient: false,
        showLegend: true,
        showXAxisLabel: false,
        xAxisLabel: '',
        showYAxisLabel: false,
        yAxisLabel: '',
        showGridLines: false,
        colorScheme: { domain: ['#e37f5b', '#9ab3bc', '#e7b053', '#67acc3', '#a7bf87', '#29748d'] },
        autoScale: false,
    }

    public lineChartSettings = {
        showXAxis: true,
        showYAxis: false,
        gradient: false,
        showLegend: false,
        showXAxisLabel: false,
        xAxisLabel: '',
        showYAxisLabel: false,
        yAxisLabel: '',
        showGridLines: true,
        colorScheme: { domain: ['#ffffff'] },
        autoScale: false,
    }

    public mmtModalData: any;

    public ssClientAge: string = '65';
    public ssSpouseAge: string = '65';
    public ssClientAgeChanged: Subject<string> = new Subject<string>();
    public ssSpouseAgeChanged: Subject<string> = new Subject<string>();

    public isHidePremiums: boolean;

    constructor(public globalService: GlobalService, public modalService: ModalService, public snackBarService: SnackBarService, public router: Router, public loadingService: LoadingService) {
        modalService.modal$.subscribe((modal) => {
            if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
                this.isHidePremiums = false;
                this.magi = 100;
                this.isSliding = false;
                // this.clientBenefit = null;
                // this.spouseBenefit = null;
                this.startingSurchargeAmount = -1;

                this.getClient('onInitialLoad');
            }
        });

        this.ssClientAgeChanged.pipe(
            debounceTime(1500))
            .subscribe(model => {
                this.magi = 100;
                this.ssClientAge = this.validateSSAge(Number(this.ssClientAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
                this.getMMTData('onSSClientAgeChanged');
            });

        this.ssSpouseAgeChanged.pipe(
            debounceTime(1500))
            .subscribe(model => {
                this.magi = 100;
                this.ssSpouseAge = this.validateSSAge(Number(this.ssSpouseAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
                this.getMMTData('onSSSpouseAgeChanged');
            });
    }

    // this.ssSpouseAge = this.validateSSAge(Number(this.ssSpouseAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'widow');
    // this.ssClientAge = this.validateSSAge(Number(this.ssClientAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'widow');

    validateSSAge(age, survivor) {
        if (!survivor) {
            if (age < 62)
                return '62';
            if (age > 70)
                return '70';
        } else {
            if (age < 60)
                return '60';
            if (age > 70)
                return '70';
        }
        return age.toString();
    }

    changedClientSSAge(text: string) {
        this.startingSurchargeAmount = -1;
        this.ssClientAgeChanged.next(text);
    }

    changedSpouseSSAge(text: string) {
        this.startingSurchargeAmount = -1;
        this.ssSpouseAgeChanged.next(text);
    }


    ngOnInit() {
        this.getClient('onInitialLoad');
        
    }

    getMMTData(scenario) {
        
        var tempReportVals = {
            InflationRate: 0.03,
            MagiIncomePercent: this.magi,
            IncludePartner: this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married',
            SocialSecurityRetirementAge: this.ssClientAge,
            SSMonthlyBenefit: this.client.clientProfile.PIA,
            PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? Number(this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "")) || 0 : this.client.clientProfile.Spouses[0] ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
            PartnerSocialSecurityAge: this.ssSpouseAge
        }

        var user = {
            UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
            CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
            ClientID: localStorage.getItem('selectedClient')
        }

        if ((Number(this.ssClientAge) >= 60 || Number(this.ssClientAge) <= 70) && (Number(this.ssSpouseAge) >= 60 || Number(this.ssSpouseAge) <= 70)) {

            //HACK: added for backwards compatibility with redesign API
            this.client.clientProfile.HCT1D = 0;
            this.client.clientProfile.HCMS = 0;
            this.client.clientProfile.HCDCW = 0;
            this.client.clientProfile.HCFHDC = 0;
            this.client.clientProfile.HCCDYrsDiag = 0;
            this.client.clientProfile.HCCYrsDiag = 0;

            this.globalService.getMMTData(this.client, tempReportVals, user)
                .subscribe(
                    data => {
                        this.createIRMAAAreaChartData(data);
                        this.createIRMAALineChartData(data);
                        this.calculateTotals(data, scenario);
                        
                        this.clientBenefit = Util.formatToCurrency(Number(data.clientSSBenfit / 12).toFixed(0) || 0);
                        this.spouseBenefit = Util.formatToCurrency(Number(data.spouseSSBenefit / 12).toFixed(0) || 0);

                        this.mmtModalData = data.IllustrationEntries.map((entry, idx) => {
                          if (entry.ClientAge >= data.Client.RetirementAge || (entry.PartnerAge && entry.PartnerAge >= data.Partner.RetirementAge)) {
                                this.mmtData = data;

                                entry.ClientAge = entry.ClientAge < this.client.clientProfile.RetirementAge ? '--' : entry.ClientAge;

                                if (entry.PartnerAge)
                                    entry.PartnerAge = entry.PartnerAge < this.client.clientProfile.Spouses[0].retirementAge ? '--' : entry.PartnerAge;

                                let updatedEntry = {
                                    yearWithAge: entry.PartnerAge ? `${entry.Year}(${entry.ClientAge}/${entry.PartnerAge})` : `${entry.Year}(${entry.ClientAge})`,
                                    magi: this.magi,
                                    fullMAGI: this.formatCurrency(entry.HouseholdIncome),
                                    percentMAGI: this.formatCurrency(entry.MagiAdjustedHouseholdIncome),
                                    updatedBracket: entry.MagiAdjustedIncomeBracket,
                                    premiums: this.formatCurrency(entry.HouseholdExpenseByBracket[0]),
                                    surcharges: this.formatCurrency(entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]),
                                    total: entry.MagiAdjustedIncomeBracket === 1 ? entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] : entry.HouseholdExpenseByBracket[0] + entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0],
                                    savings: this.formatCurrency(Math.max(0, Math.abs((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]) - (this.startingIllustration[idx].MagiAdjustedIncomeBracket === 1 ? 0 : this.startingIllustration[idx].HouseholdExpenseByBracket[this.startingIllustration[idx].MagiAdjustedIncomeBracket - 1] - this.startingIllustration[idx].HouseholdExpenseByBracket[0]))))
                                }

                                // updatedEntry.savings = this.formatCurrency(updatedEntry.savings);
                                updatedEntry.total = this.formatCurrency(updatedEntry.total);
                                return updatedEntry;
                            }
                        });

                        const totalPremiums = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.premiums) } else { return r }}, 0));
                        const totalSurcharges = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.surcharges); } else { return r }}, 0));
                        const total = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.total) } else { return r }}, 0));
                        const savings = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.savings) } else { return r }}, 0));

                        // console.log(totalSurcharges);
                        // console.log(totalPremiums);

                        this.mmtModalData.push({
                            yearWithAge: 'Total',
                            magi: '',
                            fullMAGI: '',
                            percentMAGI: '',
                            updatedBracket: '',
                            premiums: totalPremiums,
                            surcharges: totalSurcharges,
                            total: total,
                            savings: savings,
                        })

                        //console.log(this.mmtModalData);

                        this.mmtModalData = this.mmtModalData.filter((item) => {return item != undefined});
                        this.isSliding = false;
                    },
                    error => console.log(error));
        }
    }

    calculateTotals(data: any, scenario: any) {
        var ts = 0, tp = 0, tm = 0, tss = 0;
        var savings = 0;

        for (var ageRange in data.MagiAdjustedAgeRangeCosts) {
            tp += data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount;
            ts += (data.MagiAdjustedAgeRangeCosts[ageRange].Amount - data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount);
            tm += data.MagiAdjustedAgeRangeCosts[ageRange].Amount;
        }

        if (this.startingSurchargeAmount === -1 || this.changedSSAge) {
            this.startingSurchargeAmount = ts;
            this.startingIllustration = data.IllustrationEntries;
            this.changedSSAge = false;
        }
        else
            savings = Math.max(0, this.startingSurchargeAmount - ts);
        
        this.medicarePremiums = this.formatCurrency(tp);
        this.surcharges = this.formatCurrency(ts);
        this.totalMedicareCost = this.formatCurrency(tm);
        if (scenario == 'onInitialLoad') {
            if (tm == tp) {
                this.isHidePremiums = true;
            }
        }
        this.doughnutChartData = [
            {
                "name": 'Surcharge Savings',
                "value": savings,
            },
            {
                "name": 'Remaining Surcharges',
                "value": Math.max(0, tm - tp),
            },
        ];
        // this.doughnutChartData = [
        //     {
        //         "name": tm == tp ? 'Surcharges' : 'Surcharge Savings',
        //         "value": savings,
        //     },
        //     {
        //         "name": tm == tp ? 'Premiums' : 'Remaining Surcharges',
        //         "value": Math.max(0, tm == tp ? tp : tm - tp),
        //     },
        // ];

        this.totalSavings = this.formatCurrency(savings);
    }

    getClient(scenario:string) {
        this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
            .subscribe(
                client => {
                    this.client = client;

                    if (this.client.clientProfile.Spouses)
                        this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
                        if (client.clientProfile.Spouses[0].pension) {
                            client.clientProfile.Spouses[0].pension = client.clientProfile.Spouses[0].pension.replace('$','');
                            client.clientProfile.Spouses[0].pension = client.clientProfile.Spouses[0].pension.replace(',','');
                        }

                        
                    this.getMMTData(scenario);
                },
                error => console.log(error));
    }

    formatCurrency(val) {
        return '$' + val.toLocaleString();
    }

    createIRMAALineChartData(data: any) {
        const expenseYears = data.IllustrationEntries.filter((entry) => entry.HouseholdExpenseByBracket[0]);

        const lineChartData = [
            {
                name: 'Income',
                color: '#ffffff',
                series: expenseYears.map((entry) => {
                    return {
                        name: entry.Year.toString(),
                        value: entry.MagiAdjustedHouseholdIncome,
                        houseHoldIncome: this.formatCurrency(entry.MagiAdjustedHouseholdIncome),
                        clientAge: entry.ClientAge,
                        partnerAge: entry.PartnerAge ? entry.PartnerAge : 'x',
                        bracket: this.formatBracketMinimal(entry.MagiAdjustedIncomeBracket),
                        bracketHigh: this.areaChartData.reduce((result, item, i) => {
                            if (i < entry.MagiAdjustedIncomeBracket) {
                                result += item.series.reduce((r, e) => {
                                    if (entry.Year == e.name)
                                        r = e.value;
                                    return r
                                }, 0);
                            }
                            return result;
                        }, 0),
                        bracketLow: entry.MagiAdjustedIncomeBracket == 1 ? 0 : this.areaChartData.reduce((result, item, i) => {
                            if (i < entry.MagiAdjustedIncomeBracket - 1) {
                                result += item.series.reduce((r, e) => {
                                    if (entry.Year == e.name){
                                        r = e.value;
                                    }
                                    return r
                                }, 0);
                            }
                            return result;
                        }, 0),
                    }
                })
            }
        ]

        const highestBracketExpense = this.areaChartData.reduce((result, bracket) => {
            let sum = 0;

            this.areaChartData.forEach(b => {
                if (b.series[b.series.length - 1])
                    sum += b.series[b.series.length - 1].value
            });

            if (result < sum)
                result = sum;

            return result;
        }, 0);

        this.lineChartSettings['yScaleMax'] = highestBracketExpense; //this.areaChartSettings['yScaleMax'];
        this.lineChartSettings['yScaleMin'] = 0;

        Object.assign(this, { lineChartData });
    }

    createIRMAAAreaChartData(data: any) {
        const areaChartData = [
            {
                name: 'Bracket 1',
                color: '#e37f5b',
                series: data.NgxBracketCosts.Bracket1
            },
            {
                name: 'Bracket 2',
                color: '#9ab3bc',
                series: data.NgxBracketCosts.Bracket2
            },
            {
                name: 'Bracket 3',
                color: '#e7b053',
                series: data.NgxBracketCosts.Bracket3
            },
            {
                name: 'Bracket 4',
                color: '#67acc3',
                series: data.NgxBracketCosts.Bracket4
            },
            {
                name: 'Bracket 5',
                color: '#a7bf87',
                series: data.NgxBracketCosts.Bracket5
            },
            {
                name: 'Bracket 6',
                color: '#29748d',
                series: data.NgxBracketCosts.Bracket6
            }
        ]

        Object.assign(this, { areaChartData });
    }

    formatBracketMinimal(bracket: Number) {
        var affix = '';
        if (bracket === 1) {
            affix = '1st';
        } else if (bracket === 2) {
            affix = '2nd';
        } else if (bracket === 3) {
            affix = '3rd';
        } else if (bracket === 4) {
            affix = '4th';
        } else if (bracket === 5) {
            affix = '5th';
        } else {
            affix = '6th';
        }
        return affix;
    }

    public isSliding: Boolean = false;

    sliderValueChanged() {
        // this.getMMTData();

        // this.doughnutChartSettings.colorScheme = { domain: ['#d5d5d5', '#e5e5e5'] };
        // this.areaChartSettings.colorScheme = { domain: ['#e0e0e0', '#f0f0f0', '#f5f5f5', '#f8f8f8', '#ffffff', '#ffffff'] },
        
        this.isSliding = true;
        // this.getMMTData();
    }

    sliderChangeEnd() {
        // this.getMMTData();

        // this.doughnutChartSettings.colorScheme = { domain: ['#7DB72F', '#3A87C7'] };
        // this.areaChartSettings.colorScheme = { domain: ['#e18155', '#ebae58', '#a7be86', '#bdced8', '#66AEBD', '#358ca7'] };

        this.isSliding = false;
        this.getMMTData('onSliderChange');
    }

    handleEditClientModal(e) {
        this.modalService.add('add-edit-client', { ID: this.client.client.ID });
    }

    public changedSSAge:boolean = false;

    ssStartAgeChange(e, isClient) {
        if (isClient) {
            this.ssClientAge = e.target.value;
        } else {
            this.ssSpouseAge = e.target.value;
        }

        this.magi = 100;
        this.changedSSAge = true;
        this.getMMTData('onStartAgeChange');
    }

    handleProjectionModal(e) {
        this.modalService.add('mmt-projections', { mmtModalData: this.mmtModalData });
    }

    handleSaveAndDownloadReport() {
        var Report = {
          ClientID: this.client.client.ID,
          AdvisorID: this.client.client.AdvisorID,
          CompanyCode: this.client.client.OrganizationID,
          ReportTypeID: 2,
        }

        let partnerActive = this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married';
    
        var ReportMMT = {
          ClientSSMonthlyBenefit: this.client.clientProfile.PIA,
          InflationRate: 0.3, // ?
          MagiIncomePercent: this.magi,
          IncludePartner: partnerActive,
          SurvivorIncomeReductionRate: 44,
          RetirementIncomeReduction: '',
          IncomeReductionAge: '',
          IncomeReductionInflationRate: '',
          ClientSocialSecurityAge: this.ssClientAge,
          ClientPensionSurvivorBenefitPercent: 0,
          ClientLifeExpectancy: this.mmtData.Client.LifeExpectancy,
          PartnerSocialSecurityAge: this.ssSpouseAge,
          PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "") || 0 : this.client.clientProfile.Spouses[0] ? this.client.clientProfile.Spouses[0].pia || 0 : 0,
          PartnerPensionSurvivorBenefitPercent: 0,
          PartnerLifeExpectancy: this.mmtData.Partner ? this.mmtData.Partner.LifeExpectancy : 0,
          ClientCurrentAge: this.mmtData.Client.CurrentAge,
          ClientCurrentIncome: this.client.clientProfile.CurrentIncome,
          ClientGender: this.mmtData.Client.Gender,
          ClientHealthRating: this.mmtData.Client.HealthRating,
          ClientPensionAmount: this.mmtData.Client.PensionAmount,
          ClientRetirementAge: this.mmtData.Client.RetirementAge,
          FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
          FrmName1: this.mmtData.Partner ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
          PartnerCurrentAge: this.mmtData.Partner ? this.mmtData.Partner.CurrentAge : 0,
          PartnerCurrentIncome: this.mmtData.Partner ? this.mmtData.Partner.CurrentIncome : 0,
          PartnerGender: this.mmtData.Partner ? this.mmtData.Partner.Gender : 0,
          PartnerHealthRating: this.mmtData.Partner ? this.mmtData.Partner.HealthRating : 0,
          PartnerPensionAmount: this.mmtData.Partner ? this.mmtData.Partner.PensionAmount : 0,
          PartnerRetirementAge: this.mmtData.Partner ? this.mmtData.Partner.RetirementAge : 0,
          ReplacementRate: this.client.clientProfile.IRR,
          State: this.client.clientProfile.RetirementState,
          SurchargeSavings: Util.removeCurrencyFormatting(this.totalSavings),
          UseNationalAverage: this.client.clientProfile.UseNationalAverage
        }
    
        this.globalService.createReport(Report, ReportMMT)
          .subscribe(
          resp => {
            this.snackBarService.add("Please wait while your medicare means testing report is being generated.", 0);
            this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
          },
          error => { console.log(error) });
      }

      downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
        this.loadingService.isLoading(true);
        var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer") };
    
        this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
          .subscribe(
          resp => {
            // console.log('downloading report');
            this.loadingService.isLoading(false);
          },
          error => { this.loadingService.isLoading(false);});
      }
}
